var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("el-row", [_c("divider", { attrs: { label: "Dados do Ofício" } })], 1),
      _c(
        "el-row",
        { attrs: { type: "flex", gutter: 24 } },
        [
          _c(
            "el-col",
            { staticClass: "container-input", attrs: { span: 4 } },
            [
              _c("app-label", {
                attrs: { label: "Dados do Anexo:", required: false }
              }),
              _c(
                "el-select",
                {
                  staticClass: "input select",
                  attrs: {
                    name: "Dados do Anexo",
                    "no-match-text": "Nenhum dado encontrado",
                    placeholder: "Selecione",
                    "value-key": "id",
                    filterable: "filterable",
                    clearable: "clearable"
                  },
                  model: {
                    value: _vm.anexoEscolhido,
                    callback: function($$v) {
                      _vm.anexoEscolhido = $$v
                    },
                    expression: "anexoEscolhido"
                  }
                },
                _vm._l(_vm.dadosAnexos, function(dado) {
                  return _c("el-option", {
                    key: dado.codigo,
                    attrs: { label: dado.codigo, value: dado }
                  })
                }),
                1
              )
            ],
            1
          ),
          _vm._l(_vm.anexoEscolhido.labels, function(label, ind) {
            return _c(
              "el-col",
              {
                key: label,
                staticClass: "container-input",
                attrs: { span: 10 }
              },
              [
                _c("app-label", { attrs: { label: label } }),
                _c("el-input", {
                  staticClass: "input",
                  class: {
                    erro: _vm.errors[label] && !_vm.errors[label].isValid
                  },
                  on: {
                    change: function($event) {
                      return _vm.validate(label)
                    }
                  },
                  model: {
                    value: _vm.anexos[label],
                    callback: function($$v) {
                      _vm.$set(_vm.anexos, label, $$v)
                    },
                    expression: "anexos[label]"
                  }
                }),
                _vm.errors[label] && !_vm.errors[label].isValid
                  ? _c("span", { staticClass: "erro help" }, [
                      _vm._v(_vm._s(_vm.errors[label].message))
                    ])
                  : _vm._e()
              ],
              1
            )
          }),
          Object.keys(_vm.anexoEscolhido).length
            ? _c(
                "el-col",
                {
                  staticClass: "container-input align-center",
                  attrs: { span: 3 }
                },
                [
                  _c("el-button", {
                    attrs: { type: "success", icon: "el-icon-circle-plus" },
                    on: { click: _vm.adicionaAnexo }
                  }),
                  _c("span", { staticClass: "adicionar" }, [
                    _vm._v("Adicionar")
                  ])
                ],
                1
              )
            : _vm._e()
        ],
        2
      ),
      _c("el-row", [
        _vm.dadosTables.some(function(dado) {
          return dado.dados.length
        })
          ? _c(
              "div",
              { staticClass: "wrap-collabsible" },
              [
                _c(
                  "el-collapse",
                  {
                    attrs: { accordion: "accordion", value: _vm.acordionActive }
                  },
                  _vm._l(_vm.dadosTables, function(dados) {
                    return dados.dados.length
                      ? _c(
                          "el-collapse-item",
                          {
                            key: dados.codigo,
                            attrs: { title: dados.codigo, name: dados.codigo }
                          },
                          [
                            _c("table-generica", {
                              attrs: {
                                dados: dados.dados,
                                colunas: dados.colunas,
                                config: _vm.tableConfig,
                                isOneAction: true,
                                botoesAcao: _vm.excluirAnexo
                              }
                            })
                          ],
                          1
                        )
                      : _vm._e()
                  }),
                  1
                )
              ],
              1
            )
          : _vm._e()
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6588a17c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6588a17c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/screens/arrecadacao/cpat/components/oficio/DadosOficioInteiroTeor.vue
// module id = null
// module chunks = 